import { SET_FORM_TYPES } from "../../actions/action.types";

const formTypes = (state = [], action: any) => {
  if (action.type === SET_FORM_TYPES) return action.payload;
  else return state;
};

export default formTypes;
